import { GameMode } from '../types';
import type { ModeDescription } from './types';

export const FIVE_FOR_FIVE_MODE: ModeDescription = {
  mode: GameMode.FIVE_FOR_FIVE,
  title: 'Five for Five',
  description: 'Answer 5 questions at once. Fill 25 correct answers with 5 lives.',
  icon: '🧠',
};
